/**
 * GovProtocolos — Protocolos institucionais (equivalente a "assets" no privado).
 * Placeholder funcional listando conversas com número de protocolo.
 */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Files, Hash } from "@phosphor-icons/react";

export default function GovProtocolos() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/conversations", { params: { limit: 100 } });
        setRows((Array.isArray(data) ? data : (data?.items || [])).map(c => ({
          id: c.id,
          number: `${new Date(c.created_at || Date.now()).getFullYear()}${String(c.id || "").slice(0, 6).toUpperCase()}`,
          citizen: c.customer_name || c.customer_phone || "—",
          subject: c.subject || c.last_message || "—",
          status: c.status || "aberto",
          date: c.created_at,
        }))); }
      catch { setRows([]); }
      finally { setLoading(false); }
    })();
  }, []);
  return (
    <div data-testid="gov-protocolos-page">
      <div className="mb-6">
        <div className="text-[10px] uppercase tracking-[0.22em] text-emerald-700/70 font-medium mb-1">Cadastros</div>
        <h1 className="font-heading text-2xl font-semibold text-slate-900 tracking-tight flex items-center gap-2">
          <Files size={22} className="text-emerald-700" />
          Protocolos
        </h1>
        <p className="text-[12.5px] text-slate-500 mt-0.5">Protocolos gerados automaticamente para cada demanda registrada via WhatsApp.</p>
      </div>
      <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
        <table className="w-full text-[13px]">
          <thead className="bg-slate-50 border-b border-slate-200 text-[11px] uppercase tracking-wider text-slate-500">
            <tr>
              <th className="px-4 py-2.5 text-left font-medium">Nº Protocolo</th>
              <th className="px-4 py-2.5 text-left font-medium">Cidadão</th>
              <th className="px-4 py-2.5 text-left font-medium">Assunto</th>
              <th className="px-4 py-2.5 text-left font-medium">Data</th>
              <th className="px-4 py-2.5 text-left font-medium">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {loading && <tr><td colSpan={5} className="p-6 text-center text-slate-400">Carregando…</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={5} className="p-10 text-center text-slate-500 text-[12.5px]">Nenhum protocolo gerado ainda.</td></tr>}
            {!loading && rows.map(p => (
              <tr key={p.id} data-testid={`protocolo-${p.id}`} className="hover:bg-emerald-50/40 transition-colors">
                <td className="px-4 py-2.5 font-mono text-emerald-800 text-[12px] font-semibold">
                  <Hash size={11} className="inline mr-1" />{p.number}
                </td>
                <td className="px-4 py-2.5 text-slate-700">{p.citizen}</td>
                <td className="px-4 py-2.5 text-slate-600 truncate max-w-xs">{p.subject}</td>
                <td className="px-4 py-2.5 text-slate-500 text-[11.5px]">{p.date ? new Date(p.date).toLocaleDateString("pt-BR") : "—"}</td>
                <td className="px-4 py-2.5">
                  <span className="text-[11px] text-emerald-800 bg-emerald-50 border border-emerald-200 rounded px-2 py-0.5 font-medium capitalize">{p.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
